import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import useExpandable from 'Hooks/useExpandable';
import { useVulnToolsHistory, ToolsHistoryTable } from 'entities/command';
import ExpandableWrapper from '../ExpandableWrapper';
import Wrapper from './styled';

const TAB = 'general';
const ID = 'toolsHistory';

const ToolsHistory = ({ vuln }) => {
  const intl = useIntl();
  const vulnId = get(vuln, '_id', 0);
  const workspaceName = get(vuln, 'workspace_name', '');
  const { items, isLoaded } = useVulnToolsHistory(workspaceName, vulnId);

  const isExpanded = useExpandable(TAB, ID, items, isLoaded ? vulnId : null);

  return (
    <ExpandableWrapper
      defaultValue={ isExpanded }
      title={ intl.formatMessage({ id: 'manage.detail.tab.general.toolsHistory' }) }
      tab={ TAB }
      id={ ID }
      count={ items.length }
    >
      <Wrapper>
        <ToolsHistoryTable items={ items } />
      </Wrapper>
    </ExpandableWrapper>
  );
};

ToolsHistory.propTypes = {
  vuln: PropTypes.shape({
    _id: PropTypes.number,
    workspace_name: PropTypes.string
  }).isRequired
};

export default ToolsHistory;
